import React, { useCallback, useEffect } from 'react'
import WrapedSpinner from '../../../components/Spinner/WrapedSpinner';
import SmallSpinner from '../../../components/SmallSpinner/SmallSpinner';
import { useDispatch, useSelector } from 'react-redux';
import { monthsList, yearsList } from './data';
import { useRef } from 'react';
import { useLazyGetAllRequestsQuery, useLazyGetMoreRequestsQuery } from '../../../redux/apiSlices/requestSlice';
import { clearSecretaryRequestsCache, setPage, setRequestFilter, setTimeOutId } from '../../../redux/states/secretaryState';
import RequestItem from './RequestItem';
import StatusModal from './StatusModal';
import { useState } from 'react';
import UserModal from '../modals/UserModal';
import RequestInfoModal from '../modals/RequestInfoModal';
import OrganizationModal from '../modals/OrganizationModal';

function ManagerAllRequests() {

  const dispatch = useDispatch()
  const intObserver = useRef()
  const unmounted = useRef(null)

  

  const {
    requestFilter, 
    requests,
    more_pages,
    page,
	timeOutId
  } = useSelector(state => state.secretaryState)


  const [getAllRequests, {isFetching}] = useLazyGetAllRequestsQuery()
  const [loadMore, {isFetching:loadingMore}] = useLazyGetMoreRequestsQuery()

  const [showStatusModal, setShowStatusModal] = useState(false)
  const [selectedRequest, setSelectedRequest] = useState(null)

  const [showRequestInfoModal, setShowRequestInfoModal] = useState(false)

  const [showUserModal, setShowUserModal] = useState(false)

  const [query, setQuery] = useState('')
  
  const handleShowStatusModal = (rq) => {
    setSelectedRequest(rq)
    setShowStatusModal(true)
  }

  const handleShowRequestInfoModal = (rq) => {
    setSelectedRequest(rq)
    setShowRequestInfoModal(true)
  }

  const handleShowUserModal = (rq) => {
    setSelectedRequest(rq)
    setShowUserModal(true)
  }

  const handlaeSearch = async(e) => {
	e.preventDefault()

	let newRequestsFilter = {
		...requestFilter,
		query: query
	}

	console.log(newRequestsFilter)
	dispatch(setRequestFilter(newRequestsFilter))
	try {
		await getAllRequests(newRequestsFilter).unwrap()
	}catch(err){
		console.log(err)
	}
  };

  const handleChange = async(e) => {

	let newRequestsFilter = {
		...requestFilter,
		[e.target.name]: e.target.value
	}

	console.log(newRequestsFilter)
	dispatch(setRequestFilter(newRequestsFilter))
	try {
		await getAllRequests(newRequestsFilter).unwrap()
	}catch(err){
		console.log(err)
	}
  };

  const lastRequestRef = useCallback(course => {
      if (loadingMore) return

      if (intObserver.current) intObserver.current.disconnect()

      intObserver.current = new IntersectionObserver(lastCourse => {
          if (lastCourse[0].isIntersecting && more_pages) {
              console.log('We are near the last course!')
              console.log('last course:',lastCourse)
			  try {
				  let queryOptions = {
					  ...requestFilter,
			
					  page: page + 1
					}
					loadMore(queryOptions).unwrap()
					dispatch(setPage(page + 1))
			  }catch(err) {
				console.log('something went wrong',err)
			  }
          }
      })

      if (course) intObserver.current.observe(course)
  }, [loadingMore, more_pages])


  useEffect(()=>{
	const fetchRequests = async() => {
		try {
			console.log(requestFilter)
			await getAllRequests(requestFilter).unwrap()
		}catch(err){
			console.log(err)
		}
	}
	if (!requests.length && !unmounted.current) {
		fetchRequests()
	}

	if (timeOutId) {
		clearTimeout(timeOutId)
		dispatch(setTimeOutId(null))
	}

	return () => {
		if (unmounted.current || process.env.NODE_ENV !== 'development') {
			
			const newTimeOutId = setTimeout(()=>{
				dispatch(clearSecretaryRequestsCache())
			},60000)

			dispatch(setTimeOutId(newTimeOutId))
			
		} 
		unmounted.current = true
		}
		
  },[])







  return (
	<>
	<StatusModal
      showModal={showStatusModal}
      handleCloseModal={()=> setShowStatusModal(false)}
      status={selectedRequest?.status}
	  notice={selectedRequest?.handler_notice}
      />
	<RequestInfoModal
      showModal={showRequestInfoModal}
      handleCloseModal={()=> setShowRequestInfoModal(false)}
      selectedRequest={selectedRequest}
      />
	<OrganizationModal
      showModal={showUserModal}
      handleCloseModal={()=> setShowUserModal(false)}
      selectedRequest={selectedRequest}
      />
    <div class="page-content-wrapper border">

		{/* <!-- Title --> */}
		<div class="row mb-3">
			<div class="col-12 d-sm-flex justify-content-between align-items-center">
				<h1 class="h3 mb-2 mb-sm-0">قائمة الطلبات</h1>
			</div>
		</div>



		{/* <!-- Card START --> */}
		<div class="card bg-transparent border">

			{/* <!-- Card header START --> */}
			<div class="card-header bg-light border-bottom">
				{/* <!-- Search and select START --> */}
				<div class="row g-3 align-items-center justify-content-end">
					
				<div class="col-md-4 me-auto">
								<form class="position-relative" onSubmit={handlaeSearch}>
									<input 
									class="form-control pe-5  border-0" 
									type="search" 
									placeholder="بحث عبر رقم الهوية" 
									aria-label="Search"
									onChange={(e)=> setQuery(e.target.value)}
									/>
									<button class="bg-transparent px-2 py-0 border-0 position-absolute top-50 end-0 translate-middle-y" type="submit"><i class="fas fa-search fs-6 text-primary"></i></button>
								</form>
							</div>

					<div class="col-md-3">
							<select value={requestFilter?.month} onChange={handleChange} name='month' class="form-select js-choice border-0 z-index-9" aria-label=".form-select-sm">
                  <option value="" disabled>الشهر</option>
                  <option value="">جميع الشهور</option>
                  {monthsList.map(mn=>(
                    <option key={mn.id} value={mn.number}>{mn.arabicName}</option>
                  ))}
							</select>
					</div>
					{/* <!-- Select option --> */}
					<div class="col-md-3">
							<select value={requestFilter?.year} onChange={handleChange} name='year' class="form-select js-choice border-0 z-index-9" aria-label=".form-select-sm">
                  <option value="" disabled>السنة</option>
                  <option value="">جميع السنوات</option>
                  {yearsList.map(yr=>(

                    <option key={yr.id} value={yr.year} className='dr-ltr-left'>{yr.year}</option>
                  ))}
							</select>
					</div>


				</div>
				{/* <!-- Search and select END --> */}
			</div>
			{/* <!-- Card header END --> */}

			{/* <!-- Card body START --> */}
			<div class="card-body">
				{/* <!-- Course table START --> */}
				<div class="table-responsive border-0 rounded-3">
					{/* <!-- Table START --> */}
					<table class="table table-dark-gray align-middle p-4 mb-0 table-hover">
						{/* <!-- Table head --> */}
						<thead>
							<tr>
								<th scope="col" class="border-0 rounded-start">مقدم العريضة</th>
								<th scope="col" class="border-0">العريضة</th>
								<th scope="col" class="border-0">تاريخ التقديم</th>
								<th scope="col" class="border-0">الحالة</th>
							</tr>
						</thead>
							{isFetching ? <tbody><tr><td><WrapedSpinner/></td></tr></tbody> :
						
						<tbody>
							
							{!requests?.length ? 
							<tr><td><p className='my-4 text-center'>لا توجد نتائج للخيارات المحددة</p></td></tr>
               :
              requests?.map((rq,i)=> {
				if(i+1 === requests.length) {
					return (
						<RequestItem
								 key={rq.id}
								 request={rq}
								 ref={lastRequestRef}
								 handleShowStatusModal={handleShowStatusModal}
								 handleShowRequestInfoModal={handleShowRequestInfoModal}
								 handleShowUserModal={handleShowUserModal}
								 />
					)
				} else {
					return (
						<RequestItem
								 key={rq.id}
								 request={rq}
								 handleShowStatusModal={handleShowStatusModal}
								 handleShowRequestInfoModal={handleShowRequestInfoModal}
								 handleShowUserModal={handleShowUserModal}
								 />
					)
				}
			  })}

			  {loadingMore ?
			  <div className='d-flex align-items-center'>
				<span>يتم تحميل المزيد</span>
				  <SmallSpinner/> 
			  </div> 
			  : null}



						</tbody>
}
						{/* <!-- Table body END --> */}
					</table>
					{/* <!-- Table END --> */}
				</div>
				{/* <!-- Course table END --> */}
			</div>
			{/* <!-- Card body END --> */}


		</div>
		{/* <!-- Card END --> */}
	</div>
	</>
  )
}

export default ManagerAllRequests